import { render, staticRenderFns } from "./message.vue?vue&type=template&id=7ba0a82c&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0a82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba0a82c')) {
      api.createRecord('7ba0a82c', component.options)
    } else {
      api.reload('7ba0a82c', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=7ba0a82c&scoped=true", function () {
      api.rerender('7ba0a82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/InputText/message.vue"
export default component.exports